/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

import "./FieldGroup.scss";

export interface IFieldGroupProps {
	children?: React.ReactNode;
	className?: string;
	grow?: boolean;
	preventTruncate?: boolean;
}

const FieldGroup: React.FC<IFieldGroupProps> = ({ children, className, grow, preventTruncate }) => {
	const baseClass = BEM("edt-field-group", null, {
		grow,
		truncate: !preventTruncate
	});

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()}>{children}</div>;
};

const FieldGroupMemo = React.memo(FieldGroup);

export { FieldGroupMemo as FieldGroup };
